import { useEffect, useState } from "react";
import { Alert, Box, CircularProgress, Container, Grid, Modal, Tab, Tabs, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { BarraBusqueda } from "../../common/Behelit/BarraBusqueda";
import { UserTable } from "../../componente/Admin/UserTable";
import { User } from "../../types/Usuario/User";
import { GetVoidPaginateObj, PaginateObj } from "../../types/Paginate/PaginateObjt";
import AccountService from "../../services/AccountService";
import { TabPanel } from "../../common/Behelit/TabPanel";
import { MailForm } from "../../componente/Admin/MailForm";
import { themePalette } from "../../config/theme.config";

export const AdminPage: React.FC<{}> = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [tab, setTab] = useState(0);
    const [search, setSearch] = useState('');
    const [searchUser, setSearchUser] = useState('');
    const [page, setPage] = useState<PaginateObj<User>>(GetVoidPaginateObj());
    // Funciones
    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setTab(newValue);
        //console.log(newValue);
    };
    const handleSearchChange = (value: string) => {
        setSearch(value);
    };
    const fetchUsuarios = async () => {
        setLoading(true)
        try {
            const response = await AccountService.GetAccountsPaginate();
            const data = response;
            // console.log(data);
            if (response.succeeded) {
                setPage(data);
            }
        } catch (error) {
            console.error(error)
        } finally {
            setLoading(false)
        }
    }
    const handleSearchUserChange = (value: string) => {
        setSearchUser(value);
    };
    const fetchUsuario = async () => {
        setLoading(true)
        try {
            const response = await AccountService.GetUsuarioByName(searchUser);
            const data = response;
            console.log(data);
        } catch (error) {
            console.error(error)
        } finally {
            setLoading(false)
        }
    }
    const fetchUsuariosByUsername = async () => {
        setLoading(true)
        try {
            const response = await AccountService.GetAccountsPaginateByName(search);
            const data = response;
            // console.log(data);
            if (response.succeeded) {
                setPage(data);
            }
        } catch (error) {
            console.error(error)
        } finally {
            setLoading(false)
        }
    }
    // Effect
    useEffect(() => {
        fetchUsuarios();
    }, [])
    useEffect(() => {
        fetchUsuarios();
    }, [tab])
    useEffect(() => {
        if (search.length === 0) {
            fetchUsuarios();
        }
        if (search.length < 3) return;
        const debounce = setTimeout(() => {
            fetchUsuariosByUsername();
        }, 500)
        function cleanup() {
            clearTimeout(debounce)
        }
    }, [search])
    useEffect(() => {
        if (searchUser.length === 0) {
            console.log("Nada");
        }
        if (searchUser.length < 8) return;
        const debounce = setTimeout(() => {
            fetchUsuario();
        }, 500)
        function cleanup() {
            clearTimeout(debounce)
        }
    }, [searchUser])
    return (
        <Container maxWidth="lg" style={{ padding: '20px', textAlign: 'center', marginTop: 10, border: `1px solid ${themePalette.NAVCOLOR}`, borderTopWidth: '3px', borderRadius: '5px' }}>
            <Box sx={{ display: 'flex' }}>
                <Typography variant="h4" gutterBottom style={{ fontWeight: 'bold', paddingBottom: '1%', color: `${themePalette.NAVCOLOR}` }}>
                    ADMINISTRADOR
                </Typography>
            </Box>
            <Box sx={{ display: 'flex' }}>
                <Tabs
                    value={tab}
                    onChange={handleTabChange}
                    aria-label="Pestañas interactivas"
                    sx={{ borderBottom: 1, borderColor: 'divider' }}
                >
                    <Tab label="Gestores" id="tab-0" aria-controls="tabpanel-0" />
                    <Tab label="Mail" id="tab-1" aria-controls="tabpanel-1" />
                    <Tab label="Usuarios" id="tab-2" aria-controls="tabpanel-2" />
                </Tabs>
            </Box>
            <TabPanel value={tab} index={0}>
                <Box sx={{ display: 'flex' }}>
                    <BarraBusqueda id={"busqueda"} customStyles={{ m: 1, width: '100%' }} input={search} onChange={handleSearchChange} placeholder="Buscar por usuario..." />
                </Box>
                <Box sx={{ display: 'flex' }}>
                    <Grid container spacing={2}>
                        {loading ? (
                            <CircularProgress />
                        ) : (
                            <UserTable page={page} />
                        )}
                    </Grid>
                </Box>
            </TabPanel>
            <TabPanel value={tab} index={1}>
                <Box sx={{ display: 'flex' }}>
                    <Grid container sx={{ alignContent: 'center', textAlign: 'center', alignItems: 'center' }}>
                        <Grid item sm={12}>
                            <Alert variant="outlined" severity="warning" style={{ marginTop: '1px' }}>
                                Al seleccionar esta opción, se habilitará el envío de un correo diario al usuario objetivo con la información correspondiente
                            </Alert>
                        </Grid>
                        <Grid item sm={12}>
                            <Container maxWidth={'sm'}>
                                <MailForm />
                            </Container>
                        </Grid>
                    </Grid>
                </Box>
            </TabPanel>
            {/* <TabPanel value={tab} index={2}>
                <Box sx={{ display: 'flex' }}>
                    <BarraBusqueda id={"busqueda"} customStyles={{ m: 1, width: '100%' }} input={searchUser} onChange={handleSearchUserChange} placeholder="Nombre de usuario..." />
                </Box>
            </TabPanel> */}
        </Container>
    )
}